import React from 'react';
import { RoadMapView } from '../views/RoadmapPage';

export const RoadmapController: React.FC = () => {
  return <RoadMapView />;
};
